import * as feedActions from './feed';
import * as feedingActions from './feeding';

export default {
	...feedingActions,
	...feedActions
};